"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaUserInvalidPushToken = exports.yupUserInvalidPushToken = exports.schemaBeaconChatWith = exports.schemaUserPayload = exports.schemaUser = exports.yupBeaconChatWith = exports.yupUserPayload = exports.yupUser = exports.schemaUsuario = exports.yupUsuario = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
exports.yupUsuario = yup.object({
    nome: yup.string().max(40, 'Máximo de 40 caracteres.').default('').required().label('Nome'),
    nomeLogon: yup.string().max(20, 'Máximo de 20 caracteres.').default('').required().label('Nome Logon'),
    acesso: yup.string().max(600, 'Máximo de 600 caracteres.').default('').required().label('Acesso'),
    email: yup.string().max(60, 'Máximo de 60 caracteres.').default('').email().required().label('Email'),
    senha: yup.string().label('Senha').notRequired().max(10),
    habilitado: yup.boolean().required().default(false).label('Habilitado'),
    master: yup.boolean().required().default(false).label('Master'),
    supervisor: yup.boolean().required().default(false).label('Supervisor'),
    webConsul: yup.boolean().required().default(false).label('Consulta na web'),
    webAltera: yup.boolean().required().default(false).label('Altera na web'),
    nivel: yup.number().required().integer().label('Nível').default(0),
    secretaria: yup.boolean().notRequired().label('Secretario(a)'),
    tesouraria: yup.boolean().notRequired().label('Tesoureiro(a)'),
    diretoria: yup.boolean().notRequired().label('Diretor(a)'),
    coordenacao: yup.boolean().notRequired().label('Coordenador(a)'),
});
exports.schemaUsuario = exports.yupUsuario.shape({});
// ===> USUÁRIO USADO NA AUTENTICAÇÃO DOS SISTEMAS E APPS
exports.yupUser = yup.object({
    id: yup.number().notRequired().nullable().default(undefined).label('Id do usuário'),
    deltaId: yup.string().required().default('').label('Código da Delta'),
    codigo: yup.string().required().default('').label('Código do usuário'),
    escolaId: yup.string().required().default('').label('Código do colégio'),
    tipoUsuario: yup
        .mixed()
        .oneOf(Object.values(enums_1.EUserType))
        .required()
        .default(enums_1.EUserType.Aluno)
        .label('Tipo usuário'),
    nome: yup.string().required().default('').label('Nome do usuário'),
    email: yup.string().notRequired().nullable().label('E-mail do usuário no Delta'),
    genero: yup
        .mixed()
        .oneOf([...Object.values(enums_1.ESexo), null, undefined])
        .notRequired()
        .nullable()
        .label('Gênero do usuário'),
    idade: yup.number().notRequired().nullable().default(undefined).label('Idade do usuário'),
    displayName: yup.string().notRequired().nullable().default(undefined).label('Nome do usuário'),
    photoUrl: yup.string().notRequired().nullable().default(undefined).label('URL da foto de perfil'),
    photoS3: yup.boolean().notRequired().nullable().default(false).label('Foto esta no bucket da Amazon'),
    firebaseId: yup.string().notRequired().nullable().default(undefined).label('ID do usuário no Firebase'),
    firebaseEmail: yup.string().notRequired().nullable().default(undefined).label('E-mail do usuário no Firebase'),
    aplicativos: yup.array(yup.string()).required().default([]).label('Aplicativos do usuário'),
    pushTokens: yup.array(yup.string()).required().default([]).label('Push token dos dispositivos do usuário'),
    chatWith: yup.string().notRequired().nullable().default(undefined).label('Chat com o usuário'),
    token: yup.string().required().default('').label('Token de acesso'),
    permissao: yup.string().notRequired().nullable().label('Permissão do Usuário'),
    master: yup.boolean().notRequired().nullable().default(false).label('Usuário master'),
    secretaria: yup.boolean().notRequired().label('Secretario(a)'),
    tesouraria: yup.boolean().notRequired().label('Tesoureiro(a)'),
    diretoria: yup.boolean().notRequired().label('Diretor(a)'),
    coordenacao: yup.boolean().notRequired().label('Coordenador(a)'),
});
exports.yupUserPayload = exports.yupUser.pick(['id', 'deltaId', 'escolaId', 'codigo', 'tipoUsuario', 'aplicativos']);
exports.yupBeaconChatWith = exports.yupUser.pick(['deltaId', 'escolaId', 'chatWith', 'token']);
exports.schemaUser = exports.yupUser.shape({});
exports.schemaUserPayload = exports.yupUserPayload.shape({});
exports.schemaBeaconChatWith = exports.yupBeaconChatWith.shape({});
exports.yupUserInvalidPushToken = exports.yupUser.pick(['deltaId', 'pushTokens']);
exports.schemaUserInvalidPushToken = exports.yupUserInvalidPushToken.shape({});
// ===> USUÁRIO USADO NA AUTENTICAÇÃO DOS SISTEMAS E APPS
